document.addEventListener("DOMContentLoaded", function () {
  if (!window.matchMedia("(max-width: 1099px)").matches) return;

  document.querySelectorAll(".slider-wrapper").forEach(sliderWrapper => {
    const sliderTrack = sliderWrapper.querySelector(".slider-track");
  
    const dots = sliderWrapper.querySelectorAll(".slider-dot");

    if (!sliderTrack || dots.length === 0) return;

    let currentSlide = 0;
    const totalSlides = dots.length;

    function goToSlide(index) {
      currentSlide = index;
      const offset = -index * 100;

      sliderTrack.style.transform = `translateX(${offset}%)`;
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    // Dots click
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    // ---- Swipe + Drag ----
    let startX = 0;
    let isDown = false;

    // Mobile touch start
    sliderTrack.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
    });

    sliderTrack.addEventListener("touchend", e => {
      let endX = e.changedTouches[0].clientX;
      handleSwipe(endX - startX);
    });

    // Desktop drag (for tablets with mouse/touchpad < 1100px)
    sliderTrack.addEventListener("mousedown", e => {
      isDown = true;
      startX = e.clientX;
    });

    sliderTrack.addEventListener("mouseup", e => {
      if (!isDown) return;
      isDown = false;
      handleSwipe(e.clientX - startX);
    });

    function handleSwipe(diff) {
      if (Math.abs(diff) > 50) {
        if (diff < 0 && currentSlide < totalSlides - 1) {
          goToSlide(currentSlide + 1); // swipe left → next
        } else if (diff > 0 && currentSlide > 0) {
          goToSlide(currentSlide - 1); // swipe right → prev
        }
      }
    }

    // Init first slide
    goToSlide(0);
  });




  const mediaList = document.querySelector(".product__media-list");
  const mediaSublist = document.querySelector(".product__media-sublist");
  const mq = window.matchMedia("(min-width: 1100px)");

  if (mediaList && mediaSublist) {
    function setHeight() {
      if (mq.matches) {
        let height = mediaList.offsetHeight;
        mediaSublist.style.height = height + "px";
      } else {
        // Reset height when under 1100px
        mediaSublist.style.height = "";
      }
    }

    // Run initially
    setHeight();

    // Run again on window resize
    window.addEventListener("resize", setHeight);

    // Also listen for media query changes
    mq.addEventListener("change", setHeight);
  }




});












/*------------------------------- MM JS -------------------------------*/


// document.addEventListener("DOMContentLoaded", () => {
//   const addToCartBtn = document.querySelector(".product-form__submit"); // existing add to cart
//   const customerTag = addToCartBtn?.getAttribute("data-customer-tag");

//   if (customerTag === "Wholesale") {
//     const updateAll = () => {
//       let totalQty = 0;

//       document.querySelectorAll(".itg_wholesale_variant_qty .quantity").forEach((quantityWrapper) => {
//         const input = quantityWrapper.querySelector(".quantity__input");
//         const val = parseInt(input.value) || 0;

//         const wholesaleDiv = quantityWrapper.closest(".itg_wholesale_variant_part");

//         if (val > 0) {
//           wholesaleDiv?.classList.add("active");
//         } else {
//           wholesaleDiv?.classList.remove("active");
//         }

//         totalQty += val;
//       });

//       // enable/disable Add to Cart
//       if (totalQty === 0) {
//         addToCartBtn?.setAttribute("disabled", "disabled");
//       } else {
//         addToCartBtn?.removeAttribute("disabled");
//       }
//     };

//     updateAll();

//     document.querySelectorAll(".itg_wholesale_variant_qty .quantity").forEach((quantityWrapper) => {
//       const input = quantityWrapper.querySelector(".quantity__input");
//       const plusBtn = quantityWrapper.querySelector('button[name="plus"]');
//       const minusBtn = quantityWrapper.querySelector('button[name="minus"]');

//       plusBtn.addEventListener("click", () => {
//         let currentVal = parseInt(input.value) || 0;
//         let max = parseInt(input.max) || 9999;
//         if (currentVal < max) input.value = currentVal + 1;
//         updateAll();
//       });

//       minusBtn.addEventListener("click", () => {
//         let currentVal = parseInt(input.value) || 0;
//         let min = parseInt(input.min) || 0;
//         if (currentVal > min) input.value = currentVal - 1;
//         updateAll();
//       });

//       // ✅ Manual typing validation
//       input.addEventListener("input", () => {
//         let val = parseInt(input.value) || 0;
//         let min = parseInt(input.min) || 0;
//         let max = parseInt(input.max) || 9999;

//         if (val < min) val = min;
//         if (val > max) val = max;

//         input.value = val;
//         updateAll();
//       });

//       // ✅ Fix: when user clicks outside input after typing (main bug fix)
//       input.addEventListener("blur", () => {
//         setTimeout(() => {
//           let val = parseInt(input.value) || 0;
//           let min = parseInt(input.min) || 0;
//           let max = parseInt(input.max) || 9999;

//           if (val < min) val = min;
//           if (val > max) val = max;

//           input.value = val;
//           updateAll();
//         }, 50); // tiny delay ensures DOM updates done
//       });
//     });
//   }
// });

// if (document.querySelector('.itg_bundle_id_main')) {
//     setTimeout(() => {
//         const buttons = document.querySelectorAll('.itg_wholesale_variant_qty .quantity__button[name="plus"]');
//         alert('yes');
//         buttons.forEach(button => {
//             button.click();
//             console.log('Button clicked:', button);
//         });
//     }, 500); 
// }


function triggerBundleClick() {
  const el = document.querySelector('.itg_bundle_click');
  if (el) {
    el.click();
    
   // console.log('Bundle clicked!');
  } else {
   // console.log('Element not found, trying again...');
    setTimeout(triggerBundleClick, 300); // 0.3 sec retry
  }
}
setTimeout(triggerBundleClick, 500);



window.onload = function () {
  setTimeout(buttonclick, 500);
};
window.onload = function () {
  setTimeout(buttonclick, 1000);
};
window.onload = function () {
  setTimeout(buttonclick, 1500);
};
window.onload = function () {
  setTimeout(buttonclick, 2000);
};
window.onload = function () {
  setTimeout(buttonclick, 2500);
};




  document.addEventListener("DOMContentLoaded", () => {
    const addToCartBtn = document.querySelector(".product-form__submit");
    const customerTag = addToCartBtn?.getAttribute("data-customer-tag");
    const dataProTags = addToCartBtn?.getAttribute("data-pro-tag")?.split(",") || [];

    if (customerTag === "Wholesale") {

      const updateAll = () => {
        let totalQty = 0;

        document.querySelectorAll(".itg_wholesale_variant_qty .quantity").forEach((quantityWrapper) => {
          const input = quantityWrapper.querySelector(".quantity__input");
          const val = parseInt(input.value) || 0;
          const wholesaleDiv = quantityWrapper.closest(".itg_wholesale_variant_part");

          if (val > 0) {
            wholesaleDiv?.classList.add("active");
          } else {
            wholesaleDiv?.classList.remove("active");
          }

          totalQty += val;
        });

        if (dataProTags.length > 0) {
          // Minimum quantity check using data-pro-tag
          if (totalQty < dataProTags.length) {
            addToCartBtn?.setAttribute("disabled", "disabled");
          } else {
            addToCartBtn?.removeAttribute("disabled");
          }
        } else {
          // Purana behavior: disable if totalQty = 0
          if (totalQty === 0) {
            addToCartBtn?.setAttribute("disabled", "disabled");
          } else {
            addToCartBtn?.removeAttribute("disabled");
          }
        }
      };

      updateAll();

      document.querySelectorAll(".itg_wholesale_variant_qty .quantity").forEach((quantityWrapper) => {
        const input = quantityWrapper.querySelector(".quantity__input");
        const plusBtn = quantityWrapper.querySelector('button[name="plus"]');
        const minusBtn = quantityWrapper.querySelector('button[name="minus"]');

        const step = parseInt(input.getAttribute("data-pro-step")) || 1;
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max) || 9999;

        const snapValue = (val) => {
          if (val < min) val = min;
          val = Math.floor(val / step) * step;
          if (val < min) val = min;
          if (val > max) val = max;
          return val;
        };

        plusBtn.addEventListener("click", () => {
          console.log('click');
          let currentVal = parseInt(input.value) || min;
          input.value = snapValue(currentVal + step);
          updateAll();
        });

        minusBtn.addEventListener("click", () => {
          let currentVal = parseInt(input.value) || min;
          input.value = snapValue(currentVal - step);
          updateAll();
        });

        // Typing allowed freely
        input.addEventListener("input", () => {
          updateAll(); // Just update active classes & Add-to-Cart
        });

        // Snap to step only on blur
        input.addEventListener("blur", () => {
          setTimeout(() => {
            let val = parseInt(input.value) || min;
            input.value = snapValue(val);
            updateAll();
          }, 50);
        });
        
      });


    }
  });


/*----------------- Main CART page JS Start ---------------------------*/

// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".quantity__input").forEach((input) => {
//     const step = parseInt(input.getAttribute("data-pro-step")) || 1;
//     const min = parseInt(input.min) || 0;
//     const max = parseInt(input.max) || 9999;

//     const snapValue = (val) => {
//       val = Math.floor(val / step) * step;
//       if (val < min) val = min;
//       if (val > max) val = max;
//       return val;
//     };

//     const plusBtn = input.closest(".quantity")?.querySelector(".quantity__button[name='plus']");
//     const minusBtn = input.closest(".quantity")?.querySelector(".quantity__button[name='minus']");

//     // Add new listeners only if buttons exist
//     plusBtn?.addEventListener("click", (e) => {
//       e.stopPropagation(); // avoid conflicts with other JS
//       let currentVal = parseInt(input.value) || min;
//       input.value = snapValue(currentVal + step);
//     });

//     minusBtn?.addEventListener("click", (e) => {
//       e.stopPropagation();
//       let currentVal = parseInt(input.value) || min;
//       input.value = snapValue(currentVal - step);
//     });
//   });
// });



/*----------------- Main CART page JS END ---------------------------*/



/*------------------------------- MM JS -------------------------------*/


// document.addEventListener("DOMContentLoaded", () => {
//   const checkUpdatedAppContent = () => {
//       const mainElementsClass = document.querySelectorAll('.samiWS-quickOrder-item'); 
//       const targetElements = document.querySelectorAll('.samitaWS_orderLimit_product_form');
//       if (targetElements.length > 0) {
//         targetElements.forEach(function(element) {
//           let content = element.textContent.trim();

//           let match = content.match(/least\s+(\d+)\s+products/i);
//           if (match && match[1]) {
//             let extractedValue = match[1];
//             //console.log("Extracted Value:", extractedValue);

//             const parentRow = element.closest('.form_quantity_row');
//             if (parentRow) {
//               const inputField = parentRow.querySelector('.sqvf-quantity-input');

//               mainElementsClass.forEach((elem)=>{
//                  if(  elem.classList.contains("active-product"))
//                   console.log(true);
//                 else
//                   console.log(false);
                  
//               });

//               if (inputField ) {
//                   inputField.value = extractedValue; 
//                   inputField.dispatchEvent(new Event('change')); 
//                   inputField.setAttribute('data-order-limit', extractedValue - 1);
//                   //console.log("Input updated in this row:", inputField.value);
//                 }
//               }
//             }
//           }
     
//       }
//   }
//   window.onload = function () {
//     setTimeout(function () {
//       checkUpdatedAppContent();
//     }, 2500);
//     setTimeout(function () {
//       checkUpdatedAppContent();
//     }, 3500);
//     setTimeout(function () {
//       checkUpdatedAppContent();
//     }, 4500);
//     setTimeout(function () {
//       checkUpdatedAppContent();
//     }, 5500);
//   };



// document.addEventListener("click", (event) => {
//   const clickedBtn = event.target.closest('.samiWS-atc-btn');

//   if (clickedBtn) {
//     const allProducts = document.querySelectorAll('.samiWS-quickOrder-item');
//     allProducts.forEach((item) => item.classList.remove('active-product'));

//     const clickedProduct = clickedBtn.closest('.samiWS-quickOrder-item');
//     if (clickedProduct) {
//       clickedProduct.classList.add('active-product');
//      // console.log('Class added to:', clickedProduct);
//     }
//     setTimeout(() => {
//       allProducts.forEach((productItem) => {
//         if (!productItem.classList.contains('active-product')) {
//          // console.log('Running checkUpdatedAppContent on:', productItem);
//           checkUpdatedAppContent();
//         } else {
//           //console.log('Skipped active product:', productItem);
//         }
//       });
//     }, 3000);
//   }
// });






// });




document.addEventListener("DOMContentLoaded", () => {
  const checkUpdatedAppContent = () => {
    const mainElementsClass = document.querySelectorAll('.samiWS-quickOrder-item'); 
    const targetElements = document.querySelectorAll('.samitaWS_orderLimit_product_form');

    if (targetElements.length > 0) {
      targetElements.forEach(function(element) {
        let content = element.textContent.trim();
        let match = content.match(/least\s+(\d+)\s+products/i);

        if (match && match[1]) {
          let extractedValue = match[1];
          const parentRow = element.closest('.form_quantity_row');

          if (parentRow) {
            const inputField = parentRow.querySelector('.sqvf-quantity-input');

              let activeRowElementFoundOrNot = element.closest(".samiWS-quickOrder-item")?.classList.contains('active-product') ;
             // console.log(activeRowElementFoundOrNot ) ;

                if (inputField && !activeRowElementFoundOrNot) {
                  //inputField.value = extractedValue;
                  inputField.dispatchEvent(new Event('change'));
                  inputField.setAttribute('data-order-limit', extractedValue - 1);
                  inputField.setAttribute('data-order-min', extractedValue);
                }

            // ✅ Update input only when found
            // if (inputField) {
            //   inputField.value = extractedValue;
            //   inputField.dispatchEvent(new Event('change'));
            //   inputField.setAttribute('data-order-limit', extractedValue - 1);
            // }
          }
        }
      });
    }
  };

  // ✅ Auto-call on page load
window.onload = function () {
  setTimeout(checkUpdatedAppContent, 2500);
};
window.onload = function () {
  setTimeout(checkUpdatedAppContent, 3500);
};
window.onload = function () {
  setTimeout(checkUpdatedAppContent, 4500);
};
window.onload = function () {
  setTimeout(checkUpdatedAppContent, 5500);
};
window.onload = function () {
  setTimeout(checkUpdatedAppContent, 6500);
};

  document.addEventListener("click", (event) => {
    const page_btn = event.target.closest('.pagination-number-page');
    if (page_btn) {
      setTimeout(checkUpdatedAppContent, 2500);
      setTimeout(checkUpdatedAppContent, 3500);
      setTimeout(checkUpdatedAppContent, 4500);
      setTimeout(checkUpdatedAppContent, 5500);
      setTimeout(checkUpdatedAppContent, 6500);
    }
});


  // ✅ Click event listener
  document.addEventListener("click", (event) => {
    const clickedBtn = event.target.closest('.samiWS-atc-btn');
    if (clickedBtn) {
      //console.log(clickedBtn) ;
      const allProducts = document.querySelectorAll('.samiWS-quickOrder-item');
      //allProducts.forEach((item) => item.classList.remove('active-product'));
      const clickedProduct = clickedBtn.closest('.samiWS-quickOrder-item');
      if (clickedProduct) {
        clickedProduct.classList.add('active-product');
      }
      setTimeout(() => {
        allProducts.forEach((productItem) => {
          if (!productItem.classList.contains('active-product')) {
            checkUpdatedAppContent(); 
          }
        });
      }, 3000);
    }
  });

});


/* ------------------ QUICK page Class add and button block -------------------- */

// let cartShouldStayEnabled = false; // GLOBAL FLAG
// setInterval(() => {
//   const btn = document.querySelector(".samiWS-header .samiWS-goToCartPage");
//   if (btn && !cartShouldStayEnabled) {
//     if (!btn.classList.contains("disabled-go-to-cart")) {
//       btn.classList.add("disabled-go-to-cart");
//     }
//   }

//   document.querySelectorAll('.sqvf-quantity span').forEach(span => {
//     span.addEventListener('click', function () {

//       const qtyBox = this.closest('.sqvf-quantity');
//       const input = qtyBox.querySelector('input.sqvf-quantity-input');
//       if (!input) return;

//       const value = Number(input.value);
//       const mainItem = this.closest('.samiWS-quickOrder-item');

//       if (value > 0) {
//         mainItem.classList.add('active-quick-item');

//         document.querySelectorAll(".disabled-go-to-cart").forEach(b => {
//           b.classList.remove("disabled-go-to-cart");
//         });

//         cartShouldStayEnabled = true;
//       } else {
//         mainItem.classList.remove('active-quick-item');
//       }

//       const allInputs = document.querySelectorAll('input.sqvf-quantity-input');

//       let anyGreaterThanZero = false;
//       allInputs.forEach(inp => {
//         if (Number(inp.value) > 0) {
//           anyGreaterThanZero = true;
//         }
//       });

//       if (!anyGreaterThanZero) {
//         cartShouldStayEnabled = false;
//       }

//     });
//   });


// }, 500);


let cartShouldStayEnabled = false;

document.addEventListener("click", function (e) {
  const span = e.target.closest(".sqvf-quantity span");
  if (!span) return;

  const qtyBox = span.closest(".sqvf-quantity");
  const input = qtyBox.querySelector("input.sqvf-quantity-input");
  if (!input) return;

  setTimeout(() => {
    const value = Number(input.value);
    const mainItem = span.closest('.samiWS-quickOrder-item');

    if (value > 0) {
      mainItem.classList.add('active-quick-item');

      document.querySelectorAll(".disabled-go-to-cart").forEach(b => {
        b.classList.remove("disabled-go-to-cart");
      });

      cartShouldStayEnabled = true;
    } else {
      mainItem.classList.remove('active-quick-item');
    }

    // Check if any input > 0
    let anyGreaterThanZero = false;
    document.querySelectorAll("input.sqvf-quantity-input").forEach(inp => {
      if (Number(inp.value) > 0) anyGreaterThanZero = true;
    });

    if (!anyGreaterThanZero) {
      cartShouldStayEnabled = false;
    }

  }, 30); 
});


setInterval(() => {
  const btn = document.querySelector(".samiWS-header .samiWS-goToCartPage");

  if (btn && !cartShouldStayEnabled) {
    btn.classList.add("disabled-go-to-cart");
  }
}, 200);



/* ------------ QUICK Page BULK Add TO Cart ------- */


setInterval(() => {
  const goBtn = document.querySelector("button.samiWS-goToCartPage");
  if (!goBtn) return;
  if (goBtn.hasAttribute("onclick")) {
    goBtn.removeAttribute("onclick");
  }

  if (!goBtn.classList.contains("trigger-seq-added")) {
    goBtn.classList.add("trigger-seq-added");
    goBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
     // console.log("Go to Cart BLOCKED — starting 1-by-1 trigger…");
      const activeItems = document.querySelectorAll(
        ".samiWS-quickOrder-item.active-quick-item"
      );
      let index = 0;
      function triggerNext() {
        if (index === activeItems.length) {
         // console.log("LAST PRODUCT TRIGGERED — clicking cart icon...");
            setTimeout(() => {
              //----CART DRAWER
              // const cartIcon = document.querySelector(".header-top__right .header__cart");
              // if (cartIcon) {
              //  // console.log("Clicking Cart Icon after delay…");
              //   cartIcon.click();
              // }
              //----CART PAGE
              window.location.href = "/cart";  
            }, 4000);
          return;
        }
        const addBtn = activeItems[index].querySelector(".samiWS-addCart-btn");
        if (addBtn) {
          //console.log("Triggering item:", index + 1);
          addBtn.click();  // <-- EXACT LAST TRIGGER LINE
        }
        index++;
        setTimeout(triggerNext, 300);
      }
      triggerNext();
      return false;
    });
  }
}, 300);




document.addEventListener("input", (event) => {
  const input = event.target.closest('.sqvf-quantity-input');
  if (!input) return;

  const minLimit = parseInt(input.getAttribute('data-order-limit')) || 1;
  let val = parseInt(input.value);

  // If typing below limit, just show minimum
  if (isNaN(val) || val < minLimit) {
    input.value = minLimit;
  }
});

document.addEventListener("blur", (event) => {
  const input = event.target.closest('.sqvf-quantity-input');
  if (!input) return;
  if (!input.hasAttribute('data-order-min')) return;
  const minLimit = parseInt(input.getAttribute('data-order-min')) || 1;
  let val = parseInt(input.value) || minLimit;

  setTimeout(() => {
    input.value = snapValue(val, minLimit);
    input.dispatchEvent(new Event('change'));
    updateAll && updateAll(); // If updateAll exists
  }, 50);
}, true);
function snapValue(val, step) {
  if (val < step) return step;
  let multiplier = Math.round(val / step); // Nearest multiple
  return multiplier * step;
}



document.addEventListener("click", (event) => {
  const plusBtn = event.target.closest('.sqvf-quantity-increase');
  const minusBtn = event.target.closest('.sqvf-quantity-decrease');

  if (plusBtn || minusBtn) {
    const parentRow = (plusBtn || minusBtn).closest('.form_quantity_row');
    if (parentRow) {
      const input = parentRow.querySelector('.sqvf-quantity-input');

      
      if (!input.hasAttribute('data-order-min')) return;

      const step = parseInt(input.getAttribute('data-order-limit')) || 1;
      const min_step = parseInt(input.getAttribute('data-order-min')) || 1;
      let currentVal = parseInt(input.value) || step; 

      if (plusBtn) {
        input.value = currentVal + step;
      } 
      else if (minusBtn) {
        let newValue = currentVal - step;
        // if (newValue < step) {
        //   newValue = min_step;
        // }
        input.value = newValue;
      }

      input.dispatchEvent(new Event('change'));
    }
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const tryActivateSlide = () => {
    const imgs = document.querySelectorAll('.product__media-subitem img');
    const mediaWrapper = document.querySelector('#media_wrapper');
    const targetImg = mediaWrapper?.dataset.image;

    if (!targetImg || imgs.length === 0) return false;

    for (let i = 0; i < imgs.length; i++) {
      const img = imgs[i];
      const alt = img.getAttribute('alt') || '';

      if (alt === targetImg) {
        let swiperEl = document.querySelector('.js-media-list');

        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.slideTo(i);
          return true;
        } 
      }
    }
    return false;
  };
tryActivateSlide();

});


// document.addEventListener("DOMContentLoaded", function() {
//   function checkAndLoadMore() {
//     const products = document.querySelectorAll("li.collection-product-card.new");
//     const normalProducts = document.querySelectorAll("li.collection-product-card.normal_products");
//     const loadMoreBtn = document.querySelector(".button.js-load-more");
//     if (products.length < 24 && loadMoreBtn) {
//       loadMoreBtn.click();
//       setTimeout(checkAndLoadMore, 250);
//     } else {
//       console.log("false");
//     }
//     if (normalProducts.length < 24 && loadMoreBtn){
//         loadMoreBtn.click();
//         setTimeout(checkAndLoadMore, 250);
//     } else {
//       console.log("false");
//     }
//   }
//   checkAndLoadMore();

//   let showRemainVariant = document.querySelector('.selected_option_value');
//   let variantOption = document.querySelector('[name="options[Size]"]').value;

//   if (showRemainVariant && variantOption) {
//     showRemainVariant.innerText = variantOption;
//   }

// });

/*
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth >= 768) {
    function checkAndLoadMore() {
      const products = document.querySelectorAll("li.collection-product-card.new");
      const loadMoreBtn = document.querySelector(".button.js-load-more");
      if (products.length < 24 && loadMoreBtn) {
        loadMoreBtn.click();
        setTimeout(checkAndLoadMore, 250);
      } else {
        console.log("false");
      }
    }
    checkAndLoadMore();
  } else {
    console.log("Skipped on mobile");
  }
});
*/


/*
document.addEventListener("DOMContentLoaded", function () {
  const lazyImagesWrap = document.querySelectorAll(".collection-product-card.new");
  const lazyImages = lazyImagesWrap.querySelector("img.lazy-marquee");

  if ("IntersectionObserver" in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;

          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
          }
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute("data-srcset");
          }

          observer.unobserve(img); // stop observing once loaded
        }
      });
    }, { rootMargin: "50px", threshold: 0 });

    // Observe all images
    lazyImagesWrap.forEach(img => imageObserver.observe(img));

    // Extra triggers: scroll or mouse enter
    // function triggerObserver() {
    //   lazyImages.forEach(img => imageObserver.observe(img));
    // }

    // window.addEventListener("scroll", triggerObserver, { passive: true });
    // window.addEventListener("mouseenter", triggerObserver);
    // window.addEventListener("mousemove", triggerObserver);
  } else {
    // Fallback: directly load all images if IntersectionObserver not supported
    lazyImages.forEach(img => {
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    });
  }
});

*/



// document.addEventListener("DOMContentLoaded", () => {
//   const WRAPPER_SELECTOR = ".collection-product-card.new";
//   const IMG_SELECTOR = "img.lazy-marquee";

//   // Function to load all lazy images inside a wrapper
//   function loadImagesInWrapper(wrapper) {
//     const imgs = wrapper.querySelectorAll(`${IMG_SELECTOR}[data-src], ${IMG_SELECTOR}[data-srcset]`);
//     imgs.forEach(img => {
//       if (img.dataset.src) {
//         img.src = img.dataset.src;
//         img.removeAttribute("data-src");
//       }
//       if (img.dataset.srcset) {
//         img.srcset = img.dataset.srcset;
//         img.removeAttribute("data-srcset");
//       }
//       img.classList.add("lazy-marquee--loaded");
//     });
//   }

//   if ("IntersectionObserver" in window) {
//     const observerOptions = {
//       root: null,
//       rootMargin: "300px 0px", // preload slightly before visible
//       threshold: 0.05
//     };

//     const wrapperObserver = new IntersectionObserver((entries, observer) => {
//       entries.forEach(entry => {
//         if (!entry.isIntersecting) return;

//         const wrapper = entry.target;
//         loadImagesInWrapper(wrapper);
//         observer.unobserve(wrapper); // stop observing once images are loaded
//       });
//     }, observerOptions);

//     // Observe all wrappers
//     function observeAllWrappers() {
//       document.querySelectorAll(WRAPPER_SELECTOR).forEach(wrapper => {
//         if (!wrapper.__lazyObserved) {
//           wrapperObserver.observe(wrapper);
//           wrapper.__lazyObserved = true;
//         }
//       });
//     }

//     observeAllWrappers();

//     // Watch for dynamically added wrappers (e.g., Load More feature)
//     const bodyObserver = new MutationObserver(mutations => {
//       for (const mutation of mutations) {
//         mutation.addedNodes.forEach(node => {
//           if (!(node instanceof Element)) return;
//           if (node.matches?.(WRAPPER_SELECTOR)) {
//             wrapperObserver.observe(node);
//             node.__lazyObserved = true;
//           } else {
//             node.querySelectorAll?.(WRAPPER_SELECTOR).forEach(newWrapper => {
//               wrapperObserver.observe(newWrapper);
//               newWrapper.__lazyObserved = true;
//             });
//           }
//         });
//       }
//     });

//     bodyObserver.observe(document.body, { childList: true, subtree: true });

//   } else {
//     // Fallback: load all immediately
//     document.querySelectorAll(`${WRAPPER_SELECTOR} ${IMG_SELECTOR}`).forEach(img => {
//       if (img.dataset.src) img.src = img.dataset.src;
//       if (img.dataset.srcset) img.srcset = img.dataset.srcset;
//     });
//   }
// });



document.addEventListener("click", function (e) {
  const btn = e.target.closest(".wishlist-move-cart");
  if (btn) {
   // console.log("Wishlist move cart button clicked");
    setTimeout(() => {
      const cartIcon = document.querySelector(".header-top__right .header__cart");
      if (cartIcon) {
      //  console.log("Clicking Cart Icon after delay…");
        cartIcon.click();
      } else {
        //console.log("Cart icon not found!");
      }
    }, 1000);
  }
});
